import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  const respData = {
    id: data?.id,
    ruleName: data?.ruleName,
    payeeType: data?.payeeType,
    payeeUserId: data?.payeeUserId,
    payeeVpa: data?.payeeVpa,
    payerBankId: data?.payerBankId,
    binList: data?.binList,
    binRange: data?.binRange,
    cardType: '' + data?.cardType,
    scheme: '' + data?.scheme,
    amount: data?.amount,
    transactionInitiatingEntityId: '' + data?.transactionInitiatingEntityId,
    transactionApplication: data?.transactionApplication,
    txntype: '' + data?.txntype,
    instrumentType: '' + data?.instrumentType,
    mode: data?.mode,
    activationGroup: data?.activationGroup,
    priority: data?.priority,
    processor: data?.processor,
    isActive: data?.isActive,
    isAssigned: data?.isAssigned,
  }

  return respData
}

const getFileRoutingById = (id: any, tokems: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.fileRoutingGetById),
    method: 'GET',
    cache: false,
    config: sitConfig(tokems),
    headers: getHeaders(),
    body: {
      ruleId: id,
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getFileRoutingById }
